import { useContext, useState } from "react";
import { stateContext } from "./ctx";
import Picker from "./Picker";
import {generateMeshCSS,deepCopy} from './functions'

const EditColor = ({idx,startColor}) => {
   const {schema,setSchema,setBgMesh,hue} = useContext(stateContext)
   const [color,setColor] = useState(startColor)
    

    const changeColor = (e,submit) => {
        let a = e.hsl
        a = 'hsla('+parseInt(a.h)+','+parseInt(100*a.s)+'%,'+parseInt(100*a.l)+'%,'+a.a+')';
        const newSchema = deepCopy(schema)
        newSchema[idx].c = a;
        setColor(a)
        if (submit){
            setSchema(newSchema)
        } else {
            setBgMesh(generateMeshCSS(newSchema,hue))
        }
        //setColor(a)
    }

    

    return <div className='bg-white dark:bg-slate-900 p-3'>
        <Picker hasInput={true} color={color} onChange={e=>changeColor(e)} onChangeComplete={e=>changeColor(e,true)} />
    </div>
}

export default EditColor;